<template>
  <!-- Navbar Search-->
  <form class="d-none d-md-inline-block form-inline ml-auto mr-0 mr-md-3 my-2 my-md-0">
    <div class="input-group" v-if="show">
      <input class="form-control"
             type="search"
             placeholder="Search for..."
             aria-label="Search"
             aria-describedby="basic-addon2"/>
      <div class="input-group-append">
        <button class="btn btn-secondary" type="button">
          <font-awesome-icon icon="search"/>
        </button>
      </div>
    </div>

    <div v-else>

    </div>

  </form>
</template>

<script>
export default {
  name: "NavSearchBar",

  /** mixins **/
  mixins: [],

  /** props **/
  props: {
    show : {
      type : Boolean,
      default : true
    }
  },

  /** data **/
  data() {
    return {

    }
  },

  /** methods**/
  methods: {},

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
    // console.log('This is the following',this.show)
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },

}
</script>

<style scoped>

</style>
